import isArray from 'lodash/isArray';
import isEqual from 'lodash/isEqual';

import {
  DriverConfigMeta,
  DriverSchema,
  FieldValue,
  InstrumentConfig,
  WorkcellConfig,
} from '../types';

export const getDefaultByType = (
  type: string | string[] | Record<string, unknown> | undefined
): FieldValue => {
  if (isArray(type)) return [];
  return type === 'bool' ? false : '';
};

export const compareFieldValues = (
  currentField: FieldValue | null | undefined,
  prevField: FieldValue | null | undefined,
  fieldSchema: DriverConfigMeta | undefined
): boolean => {
  const defaultValue = getDefaultByType(fieldSchema?.type);

  return !isEqual(currentField ?? defaultValue, prevField ?? defaultValue);
};

export const compareInstrumentValues = (
  currentInstrument: InstrumentConfig | undefined = {},
  prevInstrument: InstrumentConfig | undefined = {},
  instrumentSchema: DriverSchema | undefined
): boolean => {
  const allFieldNames = new Set([
    ...Object.keys(currentInstrument),
    ...Object.keys(prevInstrument),
  ]);

  return Array.from(allFieldNames).some((fieldKey) => {
    const fieldSchema = instrumentSchema?.[fieldKey];
    const currentField = currentInstrument[fieldKey];
    const prevField = prevInstrument[fieldKey];

    return compareFieldValues(currentField, prevField, fieldSchema);
  });
};

export const compareFormValues = (
  currentForm: WorkcellConfig,
  prevForm: WorkcellConfig,
  driversByInstrumentId: Record<string, { configuration: DriverSchema }>
): boolean => {
  const allInstrumentNames = new Set([
    ...Object.keys(currentForm),
    ...Object.keys(prevForm),
  ]);

  return Array.from(allInstrumentNames).some((instrumentName) => {
    const currentInstrument = currentForm[instrumentName]?.config;
    const prevInstrument = prevForm[instrumentName]?.config;
    const driverSchema = driversByInstrumentId[instrumentName]?.configuration;

    const simulateChanged =
      (currentForm[instrumentName]?.simulate ?? false) !==
      (prevForm[instrumentName]?.simulate ?? false);

    return (
      compareInstrumentValues(
        currentInstrument,
        prevInstrument,
        driverSchema
      ) || simulateChanged
    );
  });
};
